import { API_BASE } from './api';

export const dashboardService = {
  getSummary: (api, params) => api.get('/dashboard/summary', { params }),
  getByStatus: (api, params) => api.get('/dashboard/by-status', { params }),
  getByAging: (api, params) => api.get('/dashboard/by-aging', { params }),
  getByProject: (api, params) => api.get('/dashboard/by-project', { params }),
  getByPosition: (api, params) => api.get('/dashboard/by-position', { params }),
  getCandidatePool: (api, params) => api.get('/dashboard/candidate-pool', { params }),
  getDrillDown: (api, params) => api.get('/dashboard/drill-down', { params }),
  getSyncStatus: (api) => api.get('/sync/google-sheet/status'),
  syncGoogleSheet: (api, data) => api.post('/sync/google-sheet', data || {}),
  exportCSV: (api) => api.exportDashboardCSV ? api.exportDashboardCSV() : window.open(`${API_BASE.replace('/api', '')}/api/export/dashboard`, '_blank'),
};
